/* global translations */
import React, { Component } from 'react';
import get from 'lodash/get';
import SuggestionsExtendedStore from '../../stores/SuggestionsExtendedStore';
import Text from '../../../legacy/flux/components/form/Text.react';

class ExtendedFormEmail extends Component {
  state = {
    email: SuggestionsExtendedStore.getEmail(),
    showErrors: SuggestionsExtendedStore.getShowErrors(),
    error: SuggestionsExtendedStore.getEmailError(),
  };

  componentDidMount() {
    SuggestionsExtendedStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    SuggestionsExtendedStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      email: SuggestionsExtendedStore.getEmail(),
      showErrors: SuggestionsExtendedStore.getShowErrors(),
      error: SuggestionsExtendedStore.getEmailError(),
    });
  };

  updateEmail = (data) => {
    SuggestionsExtendedStore.setEmail(data.email);
    SuggestionsExtendedStore.emitChange();
  };

  render() {
    const { email, showErrors, error } = this.state;

    return (
      <div className="mbm">
        <div className="mtl mbs mlxs twb">
          {get(translations, 'txt: E-pasts, uz kuru varam Tev atbildēt', 'txt: E-pasts, uz kuru varam Tev atbildēt')}
        </div>
        <Text
          name="email"
          value={email}
          setFormData={this.updateEmail}
          errorMsg={showErrors ? get(translations, error, error) : ''}
        />
      </div>
    );
  }
}

export default ExtendedFormEmail;
